import { AZ } from '../../constants';

const CARDS = 'cards';
const LIST = 'list';
const AZ_LIST_TYPE = 'aZ';
const BANNER = 'banner';
const NON_STANDARD = 'non_standard';
const RAW_RESULTS = 'rawResults';
const AZ_HEADER_OPTIONS = [...AZ, NON_STANDARD];

export { BANNER, CARDS, LIST, AZ_LIST_TYPE, NON_STANDARD, RAW_RESULTS, AZ_HEADER_OPTIONS };
